import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Miscellaneous",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.financialReportingMisc.header"
      }
    ]
  },
  misc: {
    label: "Misc.",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.financialReportingMisc",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.financialReportingMisc"
      }
    ]
  },
  deliveryContactId: {
    label: "Delivery Contact",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "covenants.deliveryContactId",
        variant: "filled",
        parentId: "deliveryContacts",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onchange: value => {}
      }
    ]
  }
};
